import type { ActivityState } from './reducer';

export const getReportActivity = ({ activityReducer }: { activityReducer: ActivityState }) =>
	activityReducer.activity;
